exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cseit-table tr td{width:60%\n}\n.print-button-container{margin:20px 0 60px\n}\n@media print{\n.app-body{display:block !important;margin:0 !important\n}\n.cseit-table{border-collapse:unset !important;display:inline-block !important\n}\n.print-button-container,.breadcrumb,.app-footer,.sidebar{display:none !important\n}\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/t1/Admin/PrintCseit.vue
// module id = 1755
// module chunks = 0